<template>
  <div class="com-box">
    <van-collapse v-model="activeNames">
        <van-collapse-item title="上传海报图片" name="posterConf" class="collapse-item">
          <span class="title-tip">(店员分享时使用，建议尺寸750*1330)</span>
          <van-grid :column-num="2" :gutter="5" :border="false">
            <van-grid-item class="grid-item" v-for="(item, index) in imgList" :key="`${item}-${index}`">
              <div class="img-box">
                <van-image
                  width="100%"
                  height="auto"
                  fit="contain"
                  :src="item.imgUrl"
                />
                <div class="del-img-btn" @click="deleteImg(item, index)">
                  <van-icon class="del-icon" name="cross" size="12" />
                </div>
              </div>
            </van-grid-item>
            
            <van-grid-item class="grid-item">
              <van-uploader
                :before-read="beforeImgUpload" 
                :after-read="uploadImg">
                <div class="img-box add-box" :class="{uploading: isUploading}">
                  <van-loading v-if="isUploading" size="30" vertical>上传中...</van-loading>
                  <van-icon v-else name="photograph" size="30" />
                </div>
              </van-uploader>
            </van-grid-item>
          </van-grid>
        </van-collapse-item>
      </van-collapse>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Array
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      activeNames: ['posterConf'],
      imgList: [],
      isUploading: false
    }
  },
  methods: {
    initForm(val) {
      if (val) {
        this.imgList = [...val];
      }
    },
    onFormChange() {
      this.$emit('change', this.imgList);
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }

      // const isLt5M = (file.size / 1024 / 1024) > 5;
      // if (isLt5M) {
      //   this.$toast('图片大小不能超过 5MB');
      //   return false;
      // }

      return true;
    },
    uploadImg(file) {
      this.isUploading = true;
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            this.imgList.push({
              imgUrl: data[0].fileUrl
            });
            this.onFormChange();
          }
        })
        .finally(_ => {
          this.isUploading = false;
        });
    },
    isClone() {
      return this.$route.query.from == 'clone';
    },
    deleteImg(item, index) {
      let isClone = this.isClone()
      const param = {
        activityId: !isClone ? this.$route.query.activityId || '' : '',
        primaryKey: !isClone ?  item.posterId || '' : '',
        imageUrl: item.imgUrl,
        sourceType: 2
      };
      this.$api.common.deleteImg(param)
        .then(() => {
          this.imgList.splice(index, 1);
          this.onFormChange();
        });
    },
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  margin 15px
  >>> .van-collapse
    border-radius: 8px
    overflow: hidden
  .img-box
    display: flex
    justify-content: center
    align-items: center
    box-sizing: border-box
    position relative
    width 145px
    height: 200px
    border-radius: 6px
    background-color: #f0f0f0
    overflow hidden
    .del-img-btn
      position absolute
      right 0
      top 0
      width 20px 
      height 20px
      background-color rgba(0, 0, 0, 0.7)
      border-radius 0 0 0 18px
      .del-icon
        top -2px
        right -5px
        color #fff

  .add-box
    border 1px dotted #bbb
    &.uploading
      background-color: #fff
  .empty-block
    height: 42px


  .collapse-item
    >>> .van-collapse-item__title .van-cell__title
      font-weight 600
    >>> .van-collapse-item__content
      padding 0
    .title-tip
      margin-left 20px
      font-size 12px
      color #999
  .grid-item
    >>> .van-grid-item__content
      padding 8px
    
</style>